export function describe(order) {
    let description = ""
    for(let position of order.positions){
        description += position.article.product.name
    }
    return description
}
